/*
 * @Author: liqiang70 liqiang70@58.com
 * @Date: 2025-05-14 16:05:40
 * @LastEditors: liqiang70 liqiang70@58.com
 * @LastEditTime: 2025-09-02 14:18:15
 * @Description: 
 */
import React from 'react';
import "./index.scss";

const Index = ({ data }) => {

    return (
        <ul className="chefu-service-product-info">
            {data.map((item, i) => (
                <li
                    className="chefu-service-product-info-item"
                    key={`chefu-service-product-info-item${i}`}
                >
                    <img
                        className="chefu-service-product-info-item-icon"
                        src={item.icon}
                        alt={item.title}
                    />
                    <span className="chefu-service-product-info-item-title">
                        {item.title}
                    </span>
                    <span>{item.desc}</span>
                </li>
            ))}
        </ul>
    );
}

export default Index;